export const handleConnectionDetailChange = (
  key: string,
  value: string,
  formValues: any,
  handleInputChange: (name: string, value: string) => void,
) => {
  const connectionDetails = JSON.parse(formValues.connectionDetails || '{}');
  const updatedDetails = {
    ...connectionDetails,
    [key]: value,
  };
  handleInputChange('connectionDetails', JSON.stringify(updatedDetails));
};
